import toast from "react-hot-toast";


class helper {
  successtoast(msg) {
    toast.success(msg);
  }
  errortoast(msg) {
    toast.error(msg);
  }

  IsEmpty(value) {
    return value.length === 0; //true if get empty
  }
}


export const { successtoast, errortoast, IsEmpty } = new helper();